<template>
	<div class="space-intro">
		<div class="map">
			<img src="@/assets/about/corner/map.jpg" alt="" class="bg">
			<img :key="n" v-for="n in 11" :slide-name="'slide'+n" @click="change" :class="'pin pin-'+n" :src="initIcon">
			<transition mode="out-in">
				<SpacePopup v-if="isPopShow" @closeSlide="closeSlide" :slideName="currentPop"></SpacePopup>
			</transition>
		</div>
	</div>
</template>

<script>
import SpacePopup from '@/components/space_popup'

export default {
  name: "spaceIntro",
  data() {
    return {
      initIcon: "/static/assets/corner/btn_spot_sec.svg",
      clickedIcon: "/static/assets/corner/btn_spot_unsec.svg",
      currentPop: "slide1",
      isPopShow: false
    };
  },
  methods: {
    change: function (event) {
      $('.pin').attr('src', this.initIcon)
      $(event.target).attr('src', this.clickedIcon)
      this.currentPop = $(event.target).attr('slide-name')
      this.isPopShow = true
    },
    closeSlide: function () {
      $('.pin').attr('src', this.initIcon)
      this.isPopShow = false
    }
  },
  props: {
    ch: String,
    en: String
  },
  components: {
    SpacePopup
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../stylesheet/base.sass'
  @import '../stylesheet/layout.sass'

  .space-intro
    position: relative
    .map
      position: relative
      .bg
        width: 100%
        height: auto
      .pin
        +size(5%, 5%)
        position: absolute
      .pin-1
        top: 72%
        left: 22%
      .pin-2
        top: 66%
        left: 22%
      .pin-3
        top: 60%
        left: 22%
      .pin-4
        top: 54%
        left: 22%
      .pin-5
        top: 27%
        left: 31%
      .pin-6
        top: 52%
        left: 49%
      .pin-7
        top: 53%
        left: 64%
      .pin-8
        top: 42%
        left: 64%
      .pin-9
        top: 24%
        left: 59%
      .pin-10
        top: 28%
        left: 80%
      .pin-11
        top: 19%
        left: 73%
</style>



// WEBPACK FOOTER //
// src/components/space_intro.vue